module.exports = __webpack_public_path__ + "img/f1.2a4e5788.jpg";